import React, { useEffect } from 'react'
import logoGov from '../images/logoGov.png';
import { useLocation } from 'react-router-dom';
const GovNavBar = () => {
    const location = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <nav className="flex items-center bg-govNavBar z-10 py-5 px-8 h-6 top-0 w-full">
                <a href='https://www.gov.co/' target="_blank" rel="noreferrer" >
                    <img className='h-6' src={logoGov} alt="Logo Governacion"/>
                </a>
            </nav>
            
        </>
    );
}
 
export default GovNavBar;